/* Squishy Vault (Claude 26.10.2026): Bonusleiter, Betraege in Besucherwaehrung, Ansage, Liefertermin, E-Mail-Popup. */
(function () {
  var SV = window.SV || (window.SV = {});
  var T = SV.t || {};

  function rate() {
    var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return r > 0 ? r : 1;
  }
  function waehrung() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  }
  function format(cent) {
    var v = cent / 100;
    try {
      return new Intl.NumberFormat(SV.intl || document.documentElement.lang || 'en', { style: 'currency', currency: waehrung() }).format(v);
    } catch (e) {
      return v.toFixed(2) + ' ' + waehrung();
    }
  }
  // EUR-Cent -> Cent in Besucherwaehrung (gleicher Kurs wie Shopify an der Kasse)
  SV.um = function (eur) { return Math.round(eur * rate()); };
  SV.geld = function (eur) { return format(SV.um(eur)); };
  SV.format = format;

  /* 28.10.: Stufen je Markt. Versand-Stufe = echte Gratis-Grenze des Markts (SV.gratisAb aus Shop-Metafeld
     custom.gratis_versand_ab, schreibt tools/squishy_versand.py --grenzen), nicht 39,90 EUR x Kurs. Fehlt der Wert:
     Versand-Stufe ohne Betrag weg. Stufen ueber dem Warenkorb-Deckel des Markts (SV.grenze) fallen weg (JP, CH). */
  function korbWaehrung() { return (SV.korb && SV.korb.cur) || waehrung(); }
  /* 30.10.2026 (Kassen-Pruefung): Versand in Landeswaehrung im EUR-Markt (PL PLN, SE SEK, DK DKK, CZ CZK, HU HUF).
     Shopify rechnet an der Kasse
       - das Porto mit dem Preis-Kurs (Shopify.currency.rate, enthaelt die 2 % Umrechnungsgebuehr) und rundet auf ganze Einheiten auf (HUF auf 100),
       - die Gratis-Grenze (Mindestbestellwert der Versandoption) mit dem Kurs OHNE die 2 % (rate / 1,02), ohne Rundung.
     Gemessen 30.10. per /cart/shipping_rates.json: PL 7,90 EUR -> 36 zl, gratis ab 176 zl (174 zl noch Porto); SE 89 kr / 438 kr (437 Porto);
     DK 68 kr / 299 kr (298 Porto); CZ 197 Kc / 972 Kc (971 Porto); HU 3.400 Ft / 14.600 Ft (14.400 Porto).
     Vorher zeigte die Leiste 39,90 EUR x rate = 179,19 zl, obwohl die Kasse ab ~175,7 zl gratis liefert. */
  var GEBUEHR = 1.02;
  SV.portoLokal = function (eurCent) {
    var schritt = waehrung() === 'HUF' ? 100 : 1;
    return Math.ceil(eurCent * rate() / 100 / schritt - 1e-9) * schritt * 100;
  };
  SV.grenzeLokal = function (eurCent) { return Math.ceil(eurCent * rate() / GEBUEHR / 100 - 1e-9) * 100; };
  function gratisLokal() {
    var g = SV.gratisAb;
    if (!g || !g.betrag) return null;
    if (g.waehrung === korbWaehrung()) return Math.round(g.betrag * 100);
    if (g.waehrung === 'EUR') return rate() === 1 ? Math.round(g.betrag * 100) : SV.grenzeLokal(Math.round(g.betrag * 100));  // wie die Kasse (s. o.)
    return null;
  }
  /* Versandhinweis am Preis (sv-versandhinweis.liquid): in Landeswaehrung kennt Liquid den Kurs nicht. Das Snippet liefert
     den Satz mit Link (immer richtig) und zusaetzlich den Satz mit Betrag (data-art="betrag-js", hidden, Porto/Grenze in EUR-Cent).
     Hier werden die Betraege wie an der Kasse umgerechnet und der Betrags-Satz gezeigt. Ohne JS bleibt der Link-Satz. */
  function versandHinweise(root) {
    if (rate() === 1) return;
    (root || document).querySelectorAll('.sv-versand-hinweis[data-art="betrag-js"]').forEach(function (el) {
      var k = parseInt(el.getAttribute('data-sv-vk'), 10), ab = parseInt(el.getAttribute('data-sv-vab'), 10);
      if (!(k > 0)) return;
      el.querySelectorAll('[data-sv-v="k"]').forEach(function (s) { s.textContent = format(SV.portoLokal(k)); });
      el.querySelectorAll('[data-sv-v="ab"]').forEach(function (s) { s.textContent = ab > 0 ? format(SV.grenzeLokal(ab)) : ''; });
      /* 02.11.2026 Warenkorb (sv-korb-versand): Summe ab Grenze -> "kostenlos" */
      var sub = parseInt(el.getAttribute('data-sv-sub'), 10);
      if (ab > 0 && sub >= SV.grenzeLokal(ab) && el.getAttribute('data-sv-frei')) el.innerHTML = el.getAttribute('data-sv-frei');
      var link = el.previousElementSibling;
      if (link && link.classList.contains('sv-versand-hinweis') && link.getAttribute('data-art') === 'link') link.hidden = true;
      el.hidden = false;
    });
  }
  SV.versandHinweise = versandHinweise;
  function deckelLokal() {
    var g = SV.grenze;
    return g && g.betrag && g.waehrung === korbWaehrung() ? Math.round(g.betrag * 100) : null;
  }
  /* 30.10.2026 (Kassen-Pruefung): Ein Warenkorb-Rabattcode (WELCOME10 aus dem Popup, /discount/WELCOME10) senkt die Summe, an der die
     Kasse den Gratisversand prueft. Gemessen: 39,90 EUR + WELCOME10 -> Versand 7,90 EUR, Gesamt 43,81 EUR. Die Leiste rechnet mit der Summe
     VOR dem Code (Geschenke zaehlen vor dem Code, Bestell-Job). Darum Versand-Stufe auf "vor Code" hochrechnen: Prozent p -> Grenze/(1-p),
     fester Betrag f -> Grenze + f. SV.korb.rp / rf aus sv-kern (Liquid) bzw. /cart.js (korbNeu). Nur die Leiste, nicht Laufband/Startseite. */
  function versandVorRabatt(w) {
    var k = SV.korb || {}, p = parseFloat(k.rp) || 0, f = parseInt(k.rf, 10) || 0;
    if (p > 0 && p < 100) w = Math.ceil(w / (1 - p / 100));
    return w + (f > 0 ? f : 0);
  }
  SV.stufenAktiv = function (mitRabatt) {
    var d = deckelLokal(), out = [];
    SV.stufen.forEach(function (eur, n) {
      var w = n === 1 ? gratisLokal() : SV.um(eur);
      if (n === 1 && w !== null && mitRabatt) w = versandVorRabatt(w);
      if (w === null || (d !== null && w > d)) return;
      out.push({ n: n, w: w });
    });
    return out.sort(function (a, b) { return a.w - b.w; });
  };

  function betraege(root) {
    var akt = null;
    (root || document).querySelectorAll('[data-sv-eur]').forEach(function (el) {
      var st = el.getAttribute('data-sv-stufe');
      if (st === null) { el.textContent = SV.geld(parseInt(el.getAttribute('data-sv-eur'), 10)); return; }
      akt = akt || SV.stufenAktiv();
      var a = akt.filter(function (x) { return x.n === +st; })[0];
      var satz = (el.parentElement && el.parentElement.closest('li, p, span')) || el;
      satz.style.display = a ? '' : 'none';
      if (a) el.textContent = format(a.w);
    });
  }

  /* Bonusleiter */
  function stand(sub, st) {
    var i = 0;
    while (i < st.length && sub >= st[i]) i++;
    var vor = i ? st[i - 1] : 0, nach = st[i];
    var anteil = !st.length || i >= st.length ? 1 : (i + (sub - vor) / (nach - vor)) / st.length;
    return { i: i, rest: i < st.length ? nach - sub : 0, anteil: Math.max(0, Math.min(1, anteil)) };
  }
  function bonusText(sub, akt, s) {
    var F = T.fertig || [], A = T.ansage || [];
    var naechste = function (a) { return (A[a.n] || '').replace('{x}', '<b>' + format(a.w) + '</b>'); };
    if (!akt.length) return '';
    if (sub <= 0) return akt[0].n === 0 ? T.leer.replace('{x}', '<b>' + format(akt[0].w) + '</b>') : naechste(akt[0]);
    if (s.i >= akt.length) return akt.length === 4 ? T.stufe[4] : '✓ ' + akt.map(function (a) { return F[a.n]; }).join(' · ');
    var nx = akt[s.i], vorN = s.i ? akt[s.i - 1].n : -1;
    if (vorN === nx.n - 1) return T.stufe[nx.n].replace('{rest}', '<b>' + format(s.rest) + '</b>');
    return (s.i ? '✓ ' + F[vorN] + ' · ' : '') + naechste(nx);
  }
  /* 29.10. (PL, TBT): Bonusleiste in der geschlossenen Warenkorb-Schublade erst bei Bedarf zeichnen: sobald die Schublade
     aufgeht (IntersectionObserver) oder spaetestens im Leerlauf. Kopf + Produktseite wie bisher sofort (sichtbar).
     Keine Layout-Abfrage beim Start (nur Attribut ort + offener <dialog>). */
  var bonusWarte = [], bonusIO = null;
  function bonusSpaeter(el) {
    if (bonusWarte.indexOf(el) < 0) bonusWarte.push(el);
    if (!bonusIO && 'IntersectionObserver' in window) {
      bonusIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { bonusIO.unobserve(e.target); e.target.zeichnen(); } });
      });
    }
    if (bonusIO) bonusIO.observe(el);
    if (!bonusWarte.uhr) {
      bonusWarte.uhr = 1;
      leerlauf(function () { bonusWarte.uhr = 0; bonusWarte.splice(0).forEach(function (b) { if (b.isConnected) b.zeichnen(); }); }, 2500);
    }
  }
  function leerlauf(fn, max) {
    if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: max || 2000 }); else setTimeout(fn, 300);
  }
  SV.leerlauf = leerlauf;
  var MIT = { de: 'Mit diesem Squishy:', en: 'With this squishy:', es: 'Con este squishy:', fr: 'Avec ce squishy :', it: 'Con questo squishy:',
    nl: 'Met deze squishy:', pl: 'Z tym squishy:', pt: 'Com este squishy:', sv: 'Med den här squishyn:', da: 'Med denne squishy:', cs: 'S tímhle squishy:' };
  class SvBonus extends HTMLElement {
    static get observedAttributes() { return ['data-sub', 'data-plus', 'data-ohne-versand']; }
    connectedCallback() { this.vielleicht(); }
    attributeChangedCallback() { if (this.isConnected) this.vielleicht(); }
    vielleicht() {
      if (this.svGezeichnet || this.getAttribute('data-ort') !== 'drawer' || this.closest('dialog[open]')) this.zeichnen();
      else bonusSpaeter(this);
    }
    zeichnen() {
      this.svGezeichnet = true;
      if (!T.stufe) return;
      /* 30.10. CRO: Produktseite rechnet den Preis dieses Squishys mit ein (data-plus) und sagt "Mit diesem Squishy: ..." */
      var plus = parseInt(this.getAttribute('data-plus') || '0', 10) || 0;
      var sub = (parseInt(this.getAttribute('data-sub') || '0', 10) || 0) + plus;
      /* 02.11.2026 PL: Produkt mit Tag inkl-versand (Adventskalender, kein Porto) -> Kopf- und Produkt-Leiste ohne Versand-Stufe */
      var akt = SV.stufenAktiv(true);
      if (this.hasAttribute('data-ohne-versand')) akt = akt.filter(function (a) { return a.n !== 1; });
      var s = stand(sub, akt.map(function (a) { return a.w; }));
      var p = this.querySelector('.sv-bonus__text');
      var mit = plus > 0 ? MIT[(document.documentElement.lang || '').slice(0, 2)] : '';
      if (p) p.innerHTML = (mit ? '<span class="sv-bonus__mit">' + mit + '</span> ' : '') + bonusText(sub, akt, s);
      var f = this.querySelector('.sv-bonus__fuell');
      if (f) f.style.width = (s.anteil * 100).toFixed(1) + '%';
      this.querySelectorAll('.sv-bonus__punkt').forEach(function (pk, n) {
        var k = -1;
        akt.forEach(function (a, j) { if (a.n === n) k = j; });
        pk.style.display = k < 0 ? 'none' : '';
        if (k >= 0) pk.style.setProperty('--p', ((k + 1) / akt.length * 100).toFixed(2) + '%');
        pk.classList.toggle('is-erreicht', k >= 0 && s.i > k);
        var b = pk.querySelector('b');
        if (b) b.textContent = T.stationen[n];
      });
      this.classList.toggle('is-leer', sub <= 0);
      this.setAttribute('data-stufe', s.i);
    }
  }
  if (!customElements.get('sv-bonus')) customElements.define('sv-bonus', SvBonus);

  function zwischensumme(cart) {
    var sub = cart.items_subtotal_price || 0;
    (cart.items || []).forEach(function (l) {
      if (l.properties && l.properties._geschenk) sub -= l.final_line_price;
    });
    return sub;
  }
  function korbNeu() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sub = zwischensumme(cart), rp = 0, rf = 0;
        (cart.cart_level_discount_applications || []).forEach(function (d) {
          if (d.value_type === 'percentage') rp += parseFloat(d.value) || 0; else rf += d.total_allocated_amount || 0;
        });
        var neuR = SV.korb && (SV.korb.rp !== rp || SV.korb.rf !== rf);
        if (SV.korb) { SV.korb.rp = rp; SV.korb.rf = rf; SV.korb.sub = cart.items_subtotal_price || 0; }
        document.querySelectorAll('sv-bonus').forEach(function (el) {
          if (neuR && el.getAttribute('data-sub') === String(sub) && el.svGezeichnet) el.zeichnen();
          el.setAttribute('data-sub', sub);
        });
        grenze(cart.items_subtotal_price || 0, cart.currency);
      })
      .catch(function () {});
  }
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.promise && e.promise.then) e.promise.then(korbNeu, korbNeu); else setTimeout(korbNeu, 600);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) korbNeu(); });
  document.addEventListener('cart:update', function () { setTimeout(korbNeu, 250); });

  /* ===== Warenkorb-Grenze je Land (27.10., PL: Zoll/IOSS). Grenze aus sv-kern (SV.grenze = {betrag, waehrung} oder null).
     Ueber der Grenze: html.sv-sperre (Kasse grau, Express-Knoepfe weg), Hinweis mit Betrag ueber jedem Kassen-Knopf,
     Klick auf Kasse/Express oeffnet das Popup statt zur Kasse zu gehen. Hart sperren kann nur eine Kassenregel (Bericht). */
  var grenzeZu = null;
  function grenzeGeld(cent, cur, ganz) {
    /* 28.10.: Waehrungen ohne Nachkommastellen (JPY) nie mit ,00 zeigen. Betraege kommen auch bei JPY x100 (cart.js 3.600 JPY = 360000) */
    try { if (new Intl.NumberFormat('en', { style: 'currency', currency: cur }).resolvedOptions().maximumFractionDigits === 0) ganz = true; } catch (e) {}
    var n = cent / 100, o = { minimumFractionDigits: ganz ? 0 : 2, maximumFractionDigits: ganz ? 0 : 2 };
    try {
      if (cur === 'EUR') { o.style = 'currency'; o.currency = cur; return new Intl.NumberFormat(SV.intl || document.documentElement.lang, o).format(n); }
      return new Intl.NumberFormat(SV.intl || document.documentElement.lang, o).format(n) + '\u00a0' + cur;
    } catch (e) { return n.toFixed(ganz ? 0 : 2) + ' ' + cur; }
  }
  function grenzeText(t) {
    var st = SV.grenzeStand;
    return t.replace('#BETRAG#', grenzeGeld(st.lim, st.cur, st.lim % 100 === 0)).replace('#ZUVIEL#', grenzeGeld(st.sub - st.lim, st.cur, false));
  }
  function grenze(sub, cur) {
    var g = SV.grenze, vorher = grenzeZu;
    if (!g || !g.betrag) { SV.grenzeStand = null; setzeSperre(false); return; }
    var lim = Math.round(g.betrag * 100);
    if (g.waehrung !== cur) {
      /* 30.10.2026: PL/SE/CZ/DK/HU zahlen im EUR-Markt in Landeswaehrung. EUR-Grenze mit Shopifys Kurs umrechnen (derselbe Kurs
         wie die Preise; Preise sind aufgerundet, die Sperre greift also eher etwas frueher). Andere Waehrungspaare: keine Sperre. */
      if (g.waehrung === 'EUR' && rate() !== 1) { lim = SV.um(lim); }
      else {
        if (window.console) console.info('[Squishy Vault] Warenkorb-Grenze ' + g.betrag + ' ' + g.waehrung + ' passt nicht zur Warenkorb-Waehrung ' + cur + ', keine Sperre.');
        SV.grenzeStand = null; setzeSperre(false); return;
      }
    }
    SV.grenzeStand = { sub: sub, lim: lim, cur: cur };
    var drueber = sub > SV.grenzeStand.lim;
    setzeSperre(drueber);
    if (drueber && (vorher === false || (vorher === null && /\/cart\/?$/.test(location.pathname)))) grenzePopup();
  }
  function setzeSperre(an) {
    grenzeZu = an;
    document.documentElement.classList.toggle('sv-sperre', an);
    grenzeHinweise();
  }
  function grenzeHinweise() {
    document.querySelectorAll('.sv-grenze-hinweis').forEach(function (h) { if (!grenzeZu) h.remove(); });
    if (!grenzeZu || !SV.grenzeStand || !SV.t || !SV.t.grenze) return;
    var txt = grenzeText(SV.t.grenze.hinweis);
    document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      var vor = b.previousElementSibling;
      if (vor && vor.classList.contains('sv-grenze-hinweis')) { vor.textContent = txt; return; }
      var h = document.createElement('p');
      h.className = 'sv-grenze-hinweis'; h.setAttribute('role', 'status'); h.textContent = txt;
      b.parentNode.insertBefore(h, b);
    });
  }
  function grenzePopup() {
    if (!SV.grenzeStand || !SV.t || !SV.t.grenze) return;
    var t = SV.t.grenze, d = document.getElementById('sv-grenze');
    if (!d) {
      d = document.createElement('dialog');
      d.id = 'sv-grenze'; d.className = 'sv-grenze'; d.setAttribute('aria-labelledby', 'sv-grenze-titel');
      d.innerHTML = '<div class="sv-grenze__karte"><button type="button" class="sv-grenze__zu" data-zu>' +
        '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg></button>' +
        '<p class="sv-grenze__titel" id="sv-grenze-titel"></p><p class="sv-grenze__text"></p><a class="sv-knopf sv-grenze__knopf" href="#"></a></div>';
      document.body.appendChild(d);
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-zu]')) d.close(); });
      d.querySelector('.sv-grenze__knopf').addEventListener('click', function (e) {
        if (/\/cart\/?$/.test(location.pathname)) {
          e.preventDefault(); d.close();
          var l = document.querySelector('.cart-items, cart-items-component, #MainContent'); if (l) l.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
    d.querySelector('.sv-grenze__zu').setAttribute('aria-label', t.zu);
    d.querySelector('.sv-grenze__titel').textContent = t.titel;
    d.querySelector('.sv-grenze__text').textContent = grenzeText(t.text);
    var k = d.querySelector('.sv-grenze__knopf'); k.textContent = t.knopf; k.href = (SV.korb && SV.korb.url) || '/cart';
    if (!d.open) { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } }
    k.focus({ preventScroll: true });
  }
  SV.grenzePruefen = grenze;  // fuer den Nachbau-Test
  /* Produktsicherheit: SKU der gewaehlten Variante (Horizon sendet variant:update mit detail.resource) */
  document.addEventListener('variant:update', function (e) {
    var v = e.detail && e.detail.resource;
    if (!v) return;
    document.querySelectorAll('[data-sv-sku]').forEach(function (el) { if (v.sku) el.textContent = v.sku; });
    if (v.price != null) document.querySelectorAll('sv-bonus[data-plus]').forEach(function (el) { el.setAttribute('data-plus', v.price); });
  });
  var KASSE = '[name="checkout"], a[href*="/checkout"], .additional-checkout-buttons, shopify-accelerated-checkout-cart, shopify-accelerated-checkout';
  document.addEventListener('click', function (e) {
    if (!grenzeZu || !e.target.closest || !e.target.closest(KASSE)) return;
    e.preventDefault(); e.stopImmediatePropagation(); grenzePopup();
  }, true);
  document.addEventListener('submit', function (e) {
    if (!grenzeZu) return;
    var s = e.submitter;
    if ((s && s.name === 'checkout') || /\/checkout/.test(e.target.getAttribute('action') || '')) { e.preventDefault(); e.stopImmediatePropagation(); grenzePopup(); }
  }, true);

  /* ===== Telefon-Pflicht je Land (29.10., PL): CJ liefert nach JP/CH/SG/HK nur mit Telefonnummer, die Shopify-Kasse fragt sie
     nur optional ab (Basic: keine Kassenfelder). sv-kern setzt SV.tel = {attr, wert, t} nur in diesen Maerkten, sonst null.
     Pflichtfeld vor jedem Kassen-Knopf (Warenkorb-Seite + Schublade), Wert als Warenkorb-Attribut (AJAX /cart/update.js und
     zusaetzlich als Formularfeld attributes[...] im cart-form) -> note_attributes der Bestellung -> Bestell-Job (cj_bestellen).
     Kasse erst ab 6 Ziffern (Knopf grau + aria-disabled, Klick zeigt die Fehlermeldung), Express-Knoepfe per CSS weg
     (html.sv-tel-pflicht). Horizon rendert Warenkorb-Teile per morph neu -> Felder werden nach jeder Aenderung nachgesetzt.
     Luecke wie bei der Grenze: /cart/<v>:<m>-Links und direkter /checkout-Aufruf -> Bestell-Job blockiert + Discord.
     Rueckgaengig: neu/assets/sv-vault.js.vor-telefon-2026-10-29 (+ CSS, sv-kern). ===== */
  var TEL_MIN = 6, telNr = 0, telWert = '', telGespeichert = '', telKette = null, telUhr = 0, telVersucht = false, telDurch = false;
  function telAn() { return !!(window.SV && SV.tel && SV.tel.attr); }
  function telZiffern(v) { return (String(v || '').match(/\d/g) || []).length; }
  function telOk(v) {
    v = String(v || '').trim();
    var z = telZiffern(v);
    return z >= TEL_MIN && z <= 20 && /^\+?[\d\s().\/-]+$/.test(v);
  }
  function telSpeichern() {
    var soll = telOk(telWert) ? telWert.trim() : '';
    if (soll === telGespeichert && !telKette) return Promise.resolve();
    var los = function () {
      if (soll === telGespeichert) return null;
      var a = {}; a[SV.tel.attr] = soll;
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: a })
      }).then(function (r) { if (r.ok) telGespeichert = soll; }).catch(function () {});
    };
    telKette = (telKette || Promise.resolve()).then(los).then(function () { telKette = null; });
    return telKette;
  }
  function telBox() {
    var n = ++telNr, t = SV.tel.t, d = document.createElement('div');
    d.className = 'sv-tel';
    d.innerHTML = '<label class="sv-tel__label" for="sv-tel-' + n + '"></label>' +
      '<p class="sv-tel__hinweis" id="sv-tel-h-' + n + '"></p>' +
      '<input class="sv-tel__feld" id="sv-tel-' + n + '" type="tel" inputmode="tel" autocomplete="tel" required aria-required="true"' +
      ' maxlength="30" form="cart-form" aria-describedby="sv-tel-h-' + n + ' sv-tel-f-' + n + '">' +
      '<p class="sv-tel__fehler" id="sv-tel-f-' + n + '" aria-live="polite"></p>';
    d.querySelector('label').textContent = t.label;
    d.querySelector('.sv-tel__hinweis').textContent = t.hinweis;
    var f = d.querySelector('input');
    f.name = 'attributes[' + SV.tel.attr + ']';
    f.value = telWert;
    f.addEventListener('input', function () {
      telWert = f.value;
      if (telOk(telWert)) telVersucht = false;
      telStand(f);
      clearTimeout(telUhr); telUhr = setTimeout(telSpeichern, 500);
    });
    f.addEventListener('change', function () { telSpeichern(); });
    f.addEventListener('blur', function () { if (telWert.trim() && !telOk(telWert)) telVersucht = true; telStand(); telSpeichern(); });
    f.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); telVersucht = !telOk(telWert); telStand(); telSpeichern(); } });
    return d;
  }
  /* Felder + Knopf-Zustand ueberall angleichen (ausser dem Feld, in dem gerade getippt wird) */
  function telStand(ausser) {
    var ok = telOk(telWert);
    document.querySelectorAll('.sv-tel').forEach(function (b) {
      var f = b.querySelector('input'), fe = b.querySelector('.sv-tel__fehler');
      if (f !== ausser && f.value !== telWert) f.value = telWert;
      var zeigen = !ok && telVersucht;
      f.setAttribute('aria-invalid', zeigen ? 'true' : 'false');
      if (fe.textContent !== (zeigen ? SV.tel.t.fehler : '')) fe.textContent = zeigen ? SV.tel.t.fehler : '';
    });
    document.querySelectorAll('[name="checkout"]').forEach(function (k) {
      k.classList.toggle('sv-tel-zu', !ok);
      if (ok) k.removeAttribute('aria-disabled'); else k.setAttribute('aria-disabled', 'true');
    });
  }
  function telFelder() {
    if (!telAn()) return;
    document.querySelectorAll('[name="checkout"]').forEach(function (k) {
      var p = k.parentNode;
      if (!p || p.querySelector(':scope > .sv-tel')) return;
      var vor = k.previousElementSibling, ref = (vor && vor.classList.contains('sv-grenze-hinweis')) ? vor : k;
      p.insertBefore(telBox(), ref);
    });
    telStand(document.activeElement);
  }
  function telFehler(knopf) {
    telVersucht = true;
    telStand();
    var box = (knopf && knopf.parentNode && knopf.parentNode.querySelector(':scope > .sv-tel')) || document.querySelector('.sv-tel');
    if (box) {
      var f = box.querySelector('input');
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
    }
  }
  document.addEventListener('click', function (e) {
    if (!telAn() || grenzeZu || !e.target.closest) return;
    var k = e.target.closest(KASSE);
    if (!k) return;
    if (telDurch) { telDurch = false; return; }
    if (!telOk(telWert)) { e.preventDefault(); e.stopImmediatePropagation(); telFehler(k); return; }
    // Kasse-Knopf im cart-form traegt das Feld selbst mit; Links (a[href*=checkout]) erst nach dem Speichern
    if (telOk(telWert) && telWert.trim() !== telGespeichert && !(k.name === 'checkout' && k.form)) {
      e.preventDefault(); e.stopImmediatePropagation();
      telSpeichern().then(function () { telDurch = true; k.click(); });
    }
  }, true);
  document.addEventListener('submit', function (e) {
    if (!telAn() || grenzeZu) return;
    var s = e.submitter;
    if (((s && s.name === 'checkout') || /\/checkout/.test(e.target.getAttribute('action') || '')) && !telOk(telWert)) {
      e.preventDefault(); e.stopImmediatePropagation(); telFehler(s);
    }
  }, true);
  function telStart() {
    if (!telAn()) return;
    telWert = telGespeichert = String(SV.tel.wert || '');
    telFelder();
    if (!('MutationObserver' in window)) return;
    var geplant = false;
    new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () { geplant = false; telFelder(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  SV.telOk = telOk;  // fuer den Test

  /* ===== Ratgeber-Artikel (27.10.): Inhaltsverzeichnis am Desktop offen, Produktkarten mit frischem Preis in Besucherwaehrung,
     nicht lieferbare oder geloeschte Produkte werden ausgeblendet (seo.md B2, B5) ===== */
  function artikel() {
    var art = document.querySelector('.sv-artikel');
    if (!art) return;
    if (window.innerWidth >= 990) art.querySelectorAll('.sv-inhalt details').forEach(function (d) { d.open = true; });
    var ab = art.getAttribute('data-sv-ab') || '';
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var cur = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'EUR';
    function geld(c) {
      try { return new Intl.NumberFormat(SV.intl || document.documentElement.lang, { style: 'currency', currency: cur }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
    }
    art.querySelectorAll('a.sv-produkt').forEach(function (a) {
      var h = a.getAttribute('data-handle');
      if (!h) { var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); h = m && m[1]; }
      if (!h) return;
      fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
        .then(function (p) {
          if (!p.available) { a.classList.add('sv-weg'); return; }
          var el = a.querySelector('.sv-produkt-preis'); if (!el) return;
          el.textContent = (p.price_varies ? ab + ' ' : '') + geld(p.price_min);
          if (!p.price_varies && p.compare_at_price > p.price) { var s = document.createElement('s'); s.textContent = geld(p.compare_at_price); el.appendChild(s); }
        })
        .catch(function (st) { if (st === 404) a.classList.add('sv-weg'); });
    });
  }

  /* Liefertermin: heute + 7 bis heute + 15 Werktage (Sa/So zaehlen nicht), Versandrichtlinie 26.10. */
  function werktage(d, n) { while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; }
  class SvLieferung extends HTMLElement {
    connectedCallback() {
      if (!T.liefer) return;
      var d = SV.lieferTage, a = new Date(), b = new Date();
      werktage(a, d[0]);
      werktage(b, d[1]);
      var f;
      try { f = new Intl.DateTimeFormat(SV.intl, { weekday: 'short', day: 'numeric', month: 'short' }); }
      catch (e) { f = new Intl.DateTimeFormat('en', { weekday: 'short', day: 'numeric', month: 'short' }); }
      this.innerHTML = '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M2 5.5A1.5 1.5 0 0 1 3.5 4h8A1.5 1.5 0 0 1 13 5.5V7h2.4c.5 0 .9.2 1.2.6l1.9 2.6c.3.3.5.7.5 1.1v2.7c0 .8-.7 1.5-1.5 1.5h-.6a2.5 2.5 0 0 1-4.8 0H7.9a2.5 2.5 0 0 1-4.8 0h-.6A1.5 1.5 0 0 1 1 14.5v-9zM5.5 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM13 8.5V12h4v-.7L15.3 8.5H13z"/></svg>' +
        '<span><b>' + T.liefer.replace('{a}', f.format(a)).replace('{b}', f.format(b)) + '</b><small>' + T.lieferKlein + '</small></span>';
    }
  }
  if (!customElements.get('sv-lieferung')) customElements.define('sv-lieferung', SvLieferung);

  /* Ansageleiste: Saetze wechseln alle 4,5 s, bei reduzierter Bewegung bleibt der erste stehen */
  function ansage() {
    document.querySelectorAll('.sv-ansage').forEach(function (bar) {
      var s = bar.querySelectorAll('.sv-ansage__satz');
      if (s.length < 2 || bar.dataset.svLaeuft) return;
      bar.dataset.svLaeuft = '1';
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0, pause = false;
      bar.addEventListener('mouseenter', function () { pause = true; });
      bar.addEventListener('mouseleave', function () { pause = false; });
      setInterval(function () {
        if (pause || document.hidden) return;
        s[i].classList.remove('is-aktiv');
        i = (i + 1) % s.length;
        s[i].classList.add('is-aktiv');
      }, 4500);
    });
  }

  /* E-Mail-Popup */
  var MERK = 'sv_popup';
  function lies(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function merk(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function popup() {
    var box = document.getElementById('sv-popup');
    if (!box) return;
    var gesendet = !!box.querySelector('[data-sv-gesendet]') ||
      (/[?&]customer_posted=true/.test(location.search) && (function () { try { return sessionStorage.getItem('sv_popup_sent') === '1'; } catch (e) { return false; } })());
    var letzterFokus = null;

    function zeigen(schritt) {
      box.querySelectorAll('[data-sv-schritt]').forEach(function (el) { el.hidden = el.getAttribute('data-sv-schritt') !== String(schritt); });
      letzterFokus = document.activeElement;
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-offen'); });
      var f = box.querySelector(schritt === 1 ? '#sv-popup-mail' : '[data-sv-einloesen]');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 50);
    }
    function schliessen() {
      box.classList.remove('is-offen');
      setTimeout(function () { box.hidden = true; }, 200);
      if (lies(MERK) !== 'fertig') merk(MERK, 'zu');
      if (letzterFokus && letzterFokus.focus) letzterFokus.focus({ preventScroll: true });
    }
    // Nur ein Klick genau auf die abgedunkelte Flaeche schliesst. Klicks im Cookie-Banner landen nie hier.
    box.addEventListener('click', function (e) { if (e.target === box) schliessen(); });
    box.querySelectorAll('[data-sv-zu]').forEach(function (b) { b.addEventListener('click', schliessen); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) schliessen(); });
    var form = box.querySelector('form');
    if (form) form.addEventListener('submit', function () { try { sessionStorage.setItem('sv_popup_sent', '1'); } catch (e) {} });
    var ein = box.querySelector('[data-sv-einloesen]');
    if (ein) ein.href = ein.getAttribute('href') + '?redirect=' + encodeURIComponent(location.pathname);

    if (gesendet) {
      merk(MERK, 'fertig');
      try { sessionStorage.removeItem('sv_popup_sent'); } catch (e) {}
      zeigen(2);
      return;
    }
    if (box.querySelector('.sv-popup__fehler')) { zeigen(1); return; }
    if (lies(MERK)) return;

    /* 30.10. (Clarity: Werbebesucher gingen nach Cookie-Banner + Popups nach Sekunden): Besucher aus bezahlter Werbung
       (gclid/gad/gbraid/wbraid/msclkid/utm_medium=cpc) sehen das 10-%-Popup erst ab der 2. Seite und nach 20 s. */
    var werbung = false, seiten = 1;
    try {
      if (/[?&](gclid|gad_source|gad_campaignid|gbraid|wbraid|msclkid)=|[?&]utm_medium=cpc/.test(location.search)) sessionStorage.setItem('sv_werbung', '1');
      werbung = sessionStorage.getItem('sv_werbung') === '1';
      seiten = (parseInt(sessionStorage.getItem('sv_seiten'), 10) || 0) + 1;
      sessionStorage.setItem('sv_seiten', String(seiten));
    } catch (e) {}
    if (werbung && seiten < 2) return;

    nachCookie(function () {
      setTimeout(function versuch() {
        if (lies(MERK)) return;
        // Ist gerade Warenkorb, Menue, Suche (modaler Dialog) oder der Land/Sprache-Vorschlag offen, warten wir, bis es zu ist
        if (document.querySelector('dialog[open]') || document.getElementById('sv-geo')) return setTimeout(versuch, 4000);
        zeigen(1);
      }, werbung ? 20000 : 8000);
    });
  }

  /* Ruft fn genau einmal auf, sobald kein Cookie-Banner mehr offen ist (Reihenfolge 27.10.: Cookies -> Land/Sprache -> 10 %). */
  function nachCookie(fn) {
    var los = false;
    function start() { if (!los) { los = true; fn(); } }
    document.addEventListener('visitorConsentCollected', start);
    function cookieLage() {
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (!cp) return start();
      var offen = false;
      try {
        var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
        offen = cp.shouldShowBanner && cp.shouldShowBanner() && c && c.analytics === '' && c.marketing === '';
      } catch (e) {}
      if (!offen) start();
    }
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (err) start(); else cookieLage(); });
    } else {
      start();
    }
    // Sicherheitsnetz: ist nach 6 s kein Cookie-Banner SICHTBAR (Element kann versteckt im DOM liegen), geht es trotzdem los
    function bannerSichtbar() { var bn = document.getElementById('shopify-pc__banner'); return !!(bn && bn.offsetHeight > 0 && getComputedStyle(bn).display !== 'none'); }
    (function warte(n) { setTimeout(function () { if (los) return; if (!bannerSichtbar()) start(); else if (n < 60) warte(n + 1); }, n ? 3000 : 6000); })(0);
  }

  /* "Plopp": Karten unterhalb der ersten Ansicht federn beim Reinscrollen kurz auf (260-320 ms).
     Nur transform/opacity (kein Layout-Sprung), Bild wird vorher dekodiert, reduzierte Bewegung = aus. */
  var PLOPP = 'product-card, .sv-kat__eintrag, .sv-stufen__liste li, .featured-blog-posts-card, .blog-post-card, .sv-advent, .sv-vertrauen__liste li, .sv-bewertungen';
  var ploppIO = null;
  function plopp(root) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('sv-plopp');
    if (!ploppIO) {
      ploppIO = new IntersectionObserver(function (es) {
        var n = 0;
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          ploppIO.unobserve(el);
          var img = el.querySelector('img');
          var fertig = img && img.decode && !img.complete ? Promise.race([img.decode().catch(function () {}), new Promise(function (r) { setTimeout(r, 250); })]) : Promise.resolve();
          var verz = Math.min(n++ * 45, 225);
          fertig.then(function () {
            setTimeout(function () {
              el.classList.add('sv-da');
              setTimeout(function () { el.classList.remove('sv-plopp-ziel', 'sv-da'); }, 420);
            }, verz);
          });
        });
      }, { rootMargin: '0px 100% -6% 100%' });
    }
    var h = window.innerHeight;
    (root || document).querySelectorAll(PLOPP).forEach(function (el) {
      if (el.dataset.svPlopp) return;
      el.dataset.svPlopp = '1';
      if (el.closest('dialog, .cart-drawer, .menu-drawer, #sv-popup, product-card product-card')) return;
      if (el.getBoundingClientRect().top < h) return; // erste Ansicht nie verstecken (LCP, kein Flackern)
      var eltern = el.parentElement; // 27.10.: nicht in seitlich scrollenden Leisten (Handy-Kacheln), sonst ploppt es beim Wischen nach
      if (eltern && eltern.scrollWidth > eltern.clientWidth + 4) return;
      el.classList.add('sv-plopp-ziel');
      ploppIO.observe(el);
    });
  }

  /* Gummi-Knoepfe (26.10. abends): Druecken = Squash (.sv-gedrueckt), Loslassen = federndes Wabbeln (.sv-wabbel),
     Funken beim Klick auf Hero-Knoepfe und Schnellkauf-"+", Haupt-Knopf wackelt 1x kurz, wenn er im Bild ist.
     Nur transform-Eigenschaften (CSS), reduzierte Bewegung = nur Farbe/Kante, kein Ton. */
  var GUMMI = '[id*="__sv_hero"] a.button, [id*="__sv_hero"] a.button-secondary, .sv-kat__eintrag, .sv-marke, product-card .quick-add__button, .sv-knopf, .product-form-buttons .add-to-cart-button';
  var FUNKEN = '[id*="__sv_hero"] a.button, [id*="__sv_hero"] a.button-secondary, product-card .quick-add__button';
  function ruhig() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  var gedrueckt = null;
  function loslassen(wabbeln) {
    var el = gedrueckt;
    if (!el) return;
    gedrueckt = null;
    el.classList.remove('sv-gedrueckt');
    if (!wabbeln || ruhig()) return;
    el.classList.remove('sv-wabbel', 'sv-lock');
    void el.offsetWidth; // Animation neu starten
    el.classList.add('sv-wabbel');
    setTimeout(function () { el.classList.remove('sv-wabbel'); }, 560);
  }
  function funken(x, y, viel) {
    if (ruhig() || !document.body.animate) return;
    var box = document.createElement('div');
    box.className = 'sv-funken';
    box.setAttribute('aria-hidden', 'true');
    var farben = ['#FFE45C', '#FF8DC7', '#6A3DF0', '#7CE0B5', '#FFFFFF', '#FFB800'];
    var n = viel ? 12 : 7;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('i');
      if (i % 3 === 0) p.className = 'sv-stern';
      p.style.background = farben[i % farben.length];
      if (p.style.background.indexOf('255, 255, 255') > -1 || farben[i % farben.length] === '#FFFFFF') p.style.boxShadow = '0 0 0 1px rgba(106,61,240,.35)';
      box.appendChild(p);
      var w = (Math.PI * 2 * i) / n + (Math.random() - .5) * .6;
      var d = (viel ? 62 : 36) + Math.random() * (viel ? 44 : 20);
      var dx = Math.cos(w) * d, dy = Math.sin(w) * d - (viel ? 14 : 8);
      p.animate([
        { transform: 'translate(' + x + 'px,' + y + 'px) scale(.5) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + (x + dx * .85) + 'px,' + (y + dy * .85) + 'px) scale(1.15) rotate(100deg)', opacity: 1, offset: .5 },
        { transform: 'translate(' + (x + dx) + 'px,' + (y + dy + 10) + 'px) scale(.9) rotate(140deg)', opacity: .9, offset: .72 },
        { transform: 'translate(' + (x + dx) + 'px,' + (y + dy + 22) + 'px) scale(.2) rotate(180deg)', opacity: 0 }
      ], { duration: 640 + Math.random() * 180, easing: 'cubic-bezier(.2,.8,.3,1)', fill: 'forwards' });
    }
    document.body.appendChild(box);
    setTimeout(function () { box.remove(); }, 800);
  }
  function gummiStart() {
    if (SV.gummiAn) return;
    SV.gummiAn = true;
    document.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      var el = e.target.closest && e.target.closest(GUMMI);
      if (!el) return;
      loslassen(false);
      gedrueckt = el;
      el.classList.remove('sv-wabbel', 'sv-lock');
      el.classList.add('sv-gedrueckt');
    }, { passive: true });
    document.addEventListener('pointerup', function (e) {
      var el = gedrueckt;
      if (!el) return;
      loslassen(true);
      if (el.matches(FUNKEN)) funken(e.clientX, e.clientY, !el.matches('product-card .quick-add__button'));
    }, { passive: true });
    document.addEventListener('pointercancel', function () { loslassen(false); }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      if (gedrueckt && e.target.closest && e.target.closest(GUMMI) === gedrueckt && !gedrueckt.contains(e.relatedTarget)) loslassen(true);
    }, { passive: true });
    // Hero-Link: kurz (200 ms) warten, damit man das Federn + die Funken sieht. Nur normaler Linksklick ohne Zusatztasten.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[id*="__sv_hero"] a.button[href], [id*="__sv_hero"] a.button-secondary[href]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank' || ruhig()) return;
      if (window.Shopify && Shopify.designMode) return;
      e.preventDefault();
      if (e.detail === 0) funken(a.getBoundingClientRect().left + a.offsetWidth / 2, a.getBoundingClientRect().top + a.offsetHeight / 2, true); // Tastatur
      setTimeout(function () { location.href = a.href; }, 200);
    });
  }
  function lockruf() {
    if (ruhig() || !('IntersectionObserver' in window)) return;
    var k = document.querySelector('[id*="__sv_hero"] a.button');
    if (!k || k.dataset.svLock) return;
    k.dataset.svLock = '1';
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      setTimeout(function () {
        if (gedrueckt === k || document.hidden) return;
        k.classList.add('sv-lock');
        setTimeout(function () { k.classList.remove('sv-lock'); }, 950);
      }, 2600);
    }, { threshold: .9 });
    io.observe(k);
  }

  /* Hover-Bildwechsel auf Karten (26.10. abends): nur echte Maus, nur Karten mit <sv-wechsel> (Varianten-/Bundle-Bilder).
     Sofort beim Hover das naechste Bild, dann alle 1,1 s, Ueberblendung 400 ms (opacity). Maus weg = zurueck aufs Hauptbild.
     Bilder werden erst beim Hover geladen, Breite passend zur Karte. Reduzierte Bewegung = aus. */
  function wechselStart() {
    if (SV.wechselAn || ruhig() || !window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    SV.wechselAn = true;
    document.addEventListener('pointerover', function (e) {
      var g = e.target.closest && e.target.closest('product-card .card-gallery');
      if (!g || g.svWechsel) return;
      var d = g.querySelector('sv-wechsel[data-bilder]');
      if (!d) return;
      var liste = d.getAttribute('data-bilder').trim().split(/\s+/);
      if (liste.length < 2) return;
      var breite = Math.min(1200, Math.ceil(g.offsetWidth * (window.devicePixelRatio || 1) / 120) * 120) || 480;
      var ebene = document.createElement('div');
      ebene.className = 'sv-wechsel-ebene';
      ebene.setAttribute('aria-hidden', 'true');
      g.appendChild(ebene);
      var w = g.svWechsel = { i: 0, uhr: 0, aktiv: false, bilder: [] };
      function bild(n) {
        if (!w.bilder[n]) {
          var f = document.createElement('div');
          f.className = 'sv-wechsel-bild';
          var im = new Image();
          im.alt = '';
          im.decoding = 'async';
          im.src = liste[n] + (liste[n].indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
          f.appendChild(im);
          ebene.appendChild(f);
          w.bilder[n] = { f: f, fertig: im.decode ? im.decode().catch(function () {}) : Promise.resolve() };
        }
        return w.bilder[n];
      }
      function schritt() {
        if (!w.aktiv) return;
        w.i = (w.i + 1) % liste.length;
        var n = w.i;
        if (n === 0) {
          // zurueck zum Hauptbild: Ebenen ausblenden
          w.bilder.forEach(function (b) { if (b) b.f.classList.remove('is-an', 'is-oben'); });
          w.uhr = setTimeout(schritt, 1100);
          return;
        }
        var b = bild(n);
        if (n + 1 < liste.length) bild(n + 1); // naechstes schon vorladen
        b.fertig.then(function () {
          if (!w.aktiv || w.i !== n) return;
          w.bilder.forEach(function (x) { if (x && x !== b) x.f.classList.remove('is-oben'); });
          b.f.classList.add('is-an', 'is-oben');
          // aeltere Ebenen nach der Ueberblendung aus
          setTimeout(function () { w.bilder.forEach(function (x) { if (x && x !== b && w.i === n) x.f.classList.remove('is-an'); }); }, 420);
          w.uhr = setTimeout(schritt, 1100);
        });
      }
      function an() { if (w.aktiv) return; w.aktiv = true; w.i = 0; clearTimeout(w.uhr); schritt(); }
      function aus() {
        w.aktiv = false; clearTimeout(w.uhr);
        w.bilder.forEach(function (b) { if (b) b.f.classList.remove('is-an', 'is-oben'); });
      }
      g.addEventListener('mouseenter', an);
      g.addEventListener('mouseleave', aus);
      an();
    }, { passive: true });
  }

  /* Land/Sprache vorschlagen (26.10. spaet, PL; 27.10. als Popup): keine Weiterleitung, nur ein Vorschlag. Daten aus snippets/sv-geo.liquid. */
  function geo() {
    var d = SV.geo;
    if (!d || !window.fetch || document.getElementById('sv-geo')) return;
    var merk = null;
    try { merk = localStorage.getItem('sv_geo'); } catch (e) {}
    if (merk) return;
    function merke(w) { try { localStorage.setItem('sv_geo', w); } catch (e) {} }
    function name(code) {
      try { return new Intl.DisplayNames([d.sprache], { type: 'region' }).of(code) || code; } catch (e) { return code; }
    }
    var url = '/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(d.land) +
      '&language[enabled]=true&language[exclude]=' + encodeURIComponent(d.sprache);
    fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.detected_values || !j.detected_values.country) return;
      var erkannt = j.detected_values.country.handle;
      var teile = (j.suggestions && j.suggestions[0] && j.suggestions[0].parts) || {};
      var huelle = document.createElement('div');
      huelle.id = 'sv-geo'; huelle.className = 'sv-popup sv-geo-pop';
      huelle.innerHTML = '<div class="sv-popup__karte sv-geo-karte" role="dialog" aria-modal="false"><button type="button" class="sv-popup__zu" aria-label="x">' +
        '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><div></div></div>';
      var box = huelle.querySelector('.sv-geo-karte > div');
      huelle.querySelector('.sv-geo-karte').setAttribute('aria-label', d.t.titel);
      if (erkannt && !d.laender[erkannt]) {
        box.innerHTML = '<p class="sv-geo__text"></p><div class="sv-geo__knoepfe"><a class="sv-geo__ja"></a><button type="button" class="sv-geo__nein"></button></div>';
        box.querySelector('.sv-geo__text').textContent = d.t.nicht.replace('{land}', name(erkannt));
        var a = box.querySelector('.sv-geo__ja'); a.textContent = d.t.kontakt; a.href = d.kontakt;
        box.querySelector('.sv-geo__nein').textContent = d.t.ok;
      } else {
        var land = teile.country && teile.country.handle, spr = teile.language && teile.language.handle;
        if (land && !d.laender[land]) land = null;
        if (spr && !d.sprachen[spr]) spr = null;
        if (!land && !spr) return;
        var zielLand = land || d.land, zielSpr = spr || d.sprache;
        /* 30.10. (Clarity: Werbebesucher aus FR/ES/IT/DE tippten nur dieses Popup weg): Sprache + Waehrung passen schon
           -> kein Popup. Land still im Hintergrund setzen (Versand/Lieferzeit fuers echte Land), ohne Neuladen. */
        if (zielSpr === d.sprache && d.laender[zielLand] === d.laender[d.land]) {
          var sf = document.getElementById('sv-geo-form');
          if (sf && zielLand !== d.land) {
            var fd = new FormData(sf);
            fd.set('country_code', zielLand); fd.set('language_code', zielSpr);
            fetch(sf.action, { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'manual' }).catch(function () {});
          }
          merke('still:' + zielLand);
          return;
        }
        var wahl =[name(zielLand), d.sprachen[zielSpr] || zielSpr, d.laender[zielLand]].join(' · ');
        box.innerHTML = '<p class="sv-geo__text"><span></span> <b></b></p><div class="sv-geo__knoepfe"><button type="button" class="sv-geo__ja"></button><button type="button" class="sv-geo__nein"></button></div>';
        box.querySelector('.sv-geo__text span').textContent = d.t.titel;
        box.querySelector('.sv-geo__text b').textContent = wahl;
        box.querySelector('.sv-geo__ja').textContent = d.t.wechseln;
        box.querySelector('.sv-geo__nein').textContent = d.t.nein;
        box.querySelector('.sv-geo__ja').addEventListener('click', function () {
          var f = document.getElementById('sv-geo-form');
          if (!f) return;
          f.querySelector('[name="country_code"]').value = zielLand;
          f.querySelector('[name="language_code"]').value = zielSpr;
          merke('gewechselt:' + zielLand + ':' + zielSpr);
          f.submit();
        });
      }
      /* 27.10. (PL): als Popup statt Balken. Nicht modal; zu per Nein, X, Klick daneben oder Esc (= gemerkt, kommt nicht wieder) */
      function zu() {
        merke('nein'); huelle.classList.remove('is-offen');
        document.removeEventListener('keydown', esc);
        setTimeout(function () { huelle.remove(); }, 220);
      }
      function esc(e) { if (e.key === 'Escape') zu(); }
      box.querySelector('.sv-geo__nein').addEventListener('click', zu);
      huelle.querySelector('.sv-popup__zu').addEventListener('click', zu);
      huelle.querySelector('.sv-popup__zu').setAttribute('aria-label', d.t.nein);
      huelle.addEventListener('click', function (e) { if (e.target === huelle) zu(); });
      document.addEventListener('keydown', esc);
      document.body.appendChild(huelle);
      requestAnimationFrame(function () { requestAnimationFrame(function () { huelle.classList.add('is-offen'); }); });
    }).catch(function () {});
  }


  /* Kategorie-Leiste im Kopf (27.10.2026, PL): Pfeile + Verlauf nur, wenn es in die Richtung weitergeht, Shift+Mausrad,
     aktive Kategorie in die Mitte. 27.10. (PL): kein Klein-Modus mehr, die Leiste bleibt beim Scrollen gleich gross. CSS: Block KOPF + SUCHE. */
  function leiste() {
    document.querySelectorAll('[data-sv-leiste]').forEach(function (nav) {
      if (nav.svAn) return;
      nav.svAn = 1;
      var spur = nav.querySelector('.sv-leiste__spur');
      if (!spur) return;
      var uhr = 0;
      function lage() {
        uhr = 0;
        var max = spur.scrollWidth - spur.clientWidth;
        nav.classList.toggle('kann-links', spur.scrollLeft > 4);
        nav.classList.toggle('kann-rechts', spur.scrollLeft < max - 4);
      }
      var still = 0;
      spur.addEventListener('scroll', function () {
        if (!uhr) uhr = requestAnimationFrame(lage);
        if (!still) nav.classList.add('is-scrollt');
        clearTimeout(still); still = setTimeout(function () { still = 0; nav.classList.remove('is-scrollt'); }, 160);
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(lage).observe(spur); else window.addEventListener('resize', lage);
      function schieben(r) { spur.scrollBy({ left: r * Math.max(180, spur.clientWidth * 0.7), behavior: ruhig() ? 'auto' : 'smooth' }); }
      var l = nav.querySelector('.sv-leiste__pfeil--links'), rr = nav.querySelector('.sv-leiste__pfeil--rechts');
      if (l) l.addEventListener('click', function () { schieben(-1); });
      if (rr) rr.addEventListener('click', function () { schieben(1); });
      // Shift+Mausrad: weich gleiten statt 100-px-Spruengen (27.10., PL: ruckelt). Ziel sammeln, per rAF hinterherlaufen.
      var ziel = null, lauf = 0;
      function gleiten() {
        var d = ziel - spur.scrollLeft;
        if (Math.abs(d) < 1) { spur.scrollLeft = ziel; ziel = null; lauf = 0; return; }
        spur.scrollLeft += d * 0.22;
        lauf = requestAnimationFrame(gleiten);
      }
      spur.addEventListener('wheel', function (e) {
        if (!(e.shiftKey && Math.abs(e.deltaX) < 1 && e.deltaY && spur.scrollWidth > spur.clientWidth)) return;
        e.preventDefault();
        var max = spur.scrollWidth - spur.clientWidth, schritt = e.deltaMode === 1 ? e.deltaY * 40 : e.deltaY;
        ziel = Math.max(0, Math.min(max, (ziel === null ? spur.scrollLeft : ziel) + schritt));
        if (ruhig()) { spur.scrollLeft = ziel; ziel = null; return; }
        if (!lauf) lauf = requestAnimationFrame(gleiten);
      }, { passive: false });
      var a = spur.querySelector('[aria-current]');
      if (a) spur.scrollLeft = a.offsetLeft - (spur.clientWidth - a.offsetWidth) / 2;
      lage();
    });
  }
  /* Laufband anhalten, wenn es nicht zu sehen ist (LAG-FIX 27.10.) */
  function band() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('.sv-band').forEach(function (b) {
      if (b.svBand) return;
      b.svBand = 1;
      new IntersectionObserver(function (es) { b.classList.toggle('is-aus', !es[0].isIntersecting); }).observe(b);
    });
  }
  /* Drops-Abschnitt: die grosse erste Karte braucht ein groesseres Bild als Horizons Spaltenrechnung (1/5) */
  function drops() {
    var g = document.querySelector('[id$="__sv_neu"] .resource-list--grid > :first-child');
    if (!g) return;
    g.querySelectorAll('img[srcset]').forEach(function (im) { im.sizes = '(min-width: 750px) 40vw, 100vw'; });
  }
  /* 29.10. (PL, TBT): Start in zwei Teilen. Sofort nur, was man in der ersten Ansicht sieht oder was die Kasse schuetzt
     (Betraege, Ansage, Kopf-Leiste, Banner-Bild, Laufband-Pause, Popup-Uhr, Warenkorb-Grenze). Der Rest (Plopp, Gummi-Knoepfe,
     Lockruf, Hover-Bildwechsel, Ratgeber-Preise) erst nach window.load im Leerlauf (spaetestens 2 s danach) oder beim
     ersten Antippen/Mausdruck, damit die erste Beruehrung nie ohne Gummi-Wirkung bleibt.
     Rueckgaengig: neu/assets/sv-vault.js.vor-tbt-2026-10-29. */
  var spaetLos = false;
  function spaeterTeil() {
    if (spaetLos) return;
    spaetLos = true;
    plopp();
    gummiStart();
    lockruf();
    wechselStart();
    artikel();
  }
  function init() {
    /* Bento 01.11. (PL): keine Frage mehr, Land/Sprache stellt snippets/sv-kern (Auto-Lok) automatisch um */
    leiste();
    drops();
    band();
    betraege();
    versandHinweise();
    ansage();
    popup();
    if (SV.korb) grenze(SV.korb.sub, SV.korb.cur);
    telStart();
    var nachLoad = function () { leerlauf(spaeterTeil, 2000); };
    if (document.readyState === 'complete') nachLoad(); else window.addEventListener('load', nachLoad, { once: true });
    document.addEventListener('pointerdown', spaeterTeil, { once: true, passive: true, capture: true });
    document.addEventListener('keydown', spaeterTeil, { once: true, passive: true });
  }
  // Vorab aufgebaute Seite (Speculation Rules): erst starten, wenn der Kunde sie wirklich sieht
  function los() { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init(); }
  if (document.prerendering) document.addEventListener('prerenderingchange', function () { los(); korbNeu(); }, { once: true });
  else los();
  document.addEventListener('shopify:section:load', function (e) { betraege(e.target); versandHinweise(e.target); ansage(); plopp(e.target); leiste(); });
  // Neu gerenderte Teile (Warenkorb-Schublade) bekommen ebenfalls umgerechnete Betraege
  if ('MutationObserver' in window) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        for (var j = 0; j < m[i].addedNodes.length; j++) {
          var n = m[i].addedNodes[j];
          if (n.nodeType === 1 && grenzeZu && (n.matches('[name="checkout"]') || n.querySelector('[name="checkout"]'))) grenzeHinweise();
          if (n.nodeType === 1 && (n.matches('.sv-versand-hinweis') || n.querySelector('.sv-versand-hinweis[data-art="betrag-js"]'))) versandHinweise(n.parentNode || n);  // Preisblock nach Variantenwechsel
          if (n.nodeType === 1 && (n.hasAttribute('data-sv-eur') || n.querySelector('[data-sv-eur]'))) { betraege(n.parentNode || n); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
